import { useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import RepeatingTaskModal from 'task-forms-lib/tasks/RepeatingTaskModal';
import { useRepeatingTaskModalOnSave } from 'task-forms-lib/tasks/useRepeatingTaskModalOnSave';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { DELETE_TASK_CONFIRMATION_MODAL } from '../../constants/modalTypes';
import { useDispatch } from '../../context/Redux';
import { useOnSaveEditedTask } from '../../hooks/taskForms';
import { useTaskEditPermissions } from '../../hooks/useTaskEditPermissions';
import { openModalAction } from '../../redux/actions/overlay';
import SequenceStepAlert from './SequenceStepAlert';
import TaskFormAsync from './TaskFormAsync';
import { getId } from 'customer-data-objects/record/ObjectRecordAccessors';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const renderRhumbErrorMarker = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "EDIT_TASK_PANEL_ERROR"
});
const EditTaskPanel = ({
  task,
  isLoading
}) => {
  const handleEditTask = useOnSaveEditedTask();
  const dispatch = useDispatch();
  const handleDeleteTaskClicked = useCallback(() => {
    dispatch(openModalAction({
      modalType: DELETE_TASK_CONFIRMATION_MODAL,
      modalData: {
        shouldCloseTaskPanelOnDelete: true,
        task,
        taskIds: [getId(task)]
      }
    }));
  }, [dispatch, task]);
  const isTaskEditable = useTaskEditPermissions({
    taskRecord: task
  });
  const {
    onSave: maybeShowRepeatingTaskModalAndSave,
    showModal: shouldShowRepeatingTaskModal,
    onDecisionMade,
    onClose: onCloseRepeatingTaskModal
  } = useRepeatingTaskModalOnSave(handleEditTask);
  const taskForm = /*#__PURE__*/_jsxs(TaskFormAsync, {
    onSave: maybeShowRepeatingTaskModalAndSave,
    onDelete: handleDeleteTaskClicked,
    task: task,
    edit: true,
    "data-test-id": "edit-task-form",
    renderRhumbErrorMarker: renderRhumbErrorMarker,
    disabled: !isTaskEditable,
    showPermissionTooltip: !isTaskEditable,
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "EDIT_TASK_PANEL_LOADED"
    }), /*#__PURE__*/_jsx(SequenceStepAlert, {
      task: task
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Panel, {
      width: 500,
      "data-selenium-test": "edit-task-panel",
      "data-test-id": "edit-task-panel",
      children: isLoading ?
      /*#__PURE__*/
      // TODO Look into whether form is actually rendering
      // @ts-expect-error UILoadingOverlay does not accept children prop.
      _jsx(UILoadingOverlay, {
        "data-test-id": "edit-task-panel-loading-overlay",
        contextual: true,
        children: taskForm
      }) : taskForm
    }), shouldShowRepeatingTaskModal && /*#__PURE__*/_jsx(RepeatingTaskModal, {
      onDecisionMade: (...args) => {
        onDecisionMade(...args).catch(rethrowError);
      },
      onClose: onCloseRepeatingTaskModal,
      action: "edit"
    })]
  });
};
export default EditTaskPanel;